/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_AttributionInputs */

const en_ui_weather_attribution = /** @type {(inputs: Ui_Weather_AttributionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weather data by Open-Meteo.com`)
};

const de_ui_weather_attribution = /** @type {(inputs: Ui_Weather_AttributionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetterdaten von Open-Meteo.com`)
};

/**
* | output |
* | --- |
* | "Weather data by Open-Meteo.com" |
*
* @param {Ui_Weather_AttributionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_attribution = /** @type {((inputs?: Ui_Weather_AttributionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_AttributionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_attribution(inputs)
	return de_ui_weather_attribution(inputs)
});